export default {
  domexStep: (state) => state.currentStep,
  domexPhase: (state) => state.appPhase,
  domexSubmissionRef: (state) => state.submissionRef,
  domexSameAsSubscriber: (state) => state.sameAsSubscriber,
  domexActiveBeneficiaryIndex: (state) => state.activeBeneficiaryIndex,

  domexForm: (state) => state.form,
  domexContract: (state) => state.form.contract,
  domexSubscriber: (state) => state.form.subscriber,
  domexInsured: (state) => state.form.insured,
  domexBeneficiaries: (state) => state.form.beneficiaries,
  domexActiveBeneficiary: (state) =>
    state.form.beneficiaries[state.activeBeneficiaryIndex] || {},

  domexFiles: (state) => state.files,

  domexErrors: (state) => state.errors,
  domexContractErrors: (state) => state.errors.contract,
  domexSubscriberErrors: (state) => state.errors.subscriber,
  domexInsuredErrors: (state) => state.errors.insured,
  domexBeneficiaryErrors: (state) => (idx) =>
    state.errors.beneficiaries[idx] || {},

  isDomexSubmitting: (state) => state.loading.submit,
  domexSubmitError: (state) => state.errors.submit,
  domexConsentError: (state) => state.errors.consent,

  // ── Helper de canSubmit pour l'étape finale
  domexCanSubmit: (state) =>
    state.form.consentExact &&
    state.form.consentData &&
    state.form.consentTerms,
};
